import { client, API_BASE_URL } from './api';

/**
 * Sending one or more PDFs to one fax number by hand.
 *
 * A testing tool for now: it proves a real line answers, and it is how an
 * outbound fax is exercised before the order manager has anything to send.
 * Refused unless the deployment is allowed to write to the fax provider
 * account, which is off everywhere by default.
 */

export interface SentFax {
  message_id: string;
  /** Normally "Queued": the fax provider transmits after it accepts. */
  status: string;
  to: string;
}

/**
 * Several documents go as one transmission rather than one fax each.
 *
 * A packet is a cover sheet, an order and a face to face: sent separately they
 * arrive as three faxes the far end has to work out belong together.
 */
export async function sendFax(to: string, files: File[]): Promise<SentFax> {
  const body = new FormData();
  body.append('to', to);
  for (const file of files) body.append('files', file);

  // An explicit base URL and a raw FormData body: the request must keep the
  // multipart boundary axios generates, so no serializer is passed, and a
  // relative path can otherwise resolve against the frontend origin.
  const response = await client.request<SentFax, unknown, true>({
    baseURL: API_BASE_URL,
    body,
    method: 'POST',
    responseType: 'json',
    throwOnError: true,
    url: '/internal-tools/outbound-faxes',
  });
  return response.data;
}
